const CUSTOM_TAG = 'pyro-fragment';
const ATTR_TARGET = 'target';

/**
 * implementation of the fragment element
 */
export default class PyroFragmentElement extends HTMLElement {

	/**
	 * constructs a new instance
	 */
	constructor() {
		super();
		const self = this;
		document.addEventListener('DOMContentLoaded', () => self._onLoaded())
	}

    /**
     * called after the element was connected to the DOM
     */
	 connectedCallback() {
		console.debug('<pyro-fragment> element connected.');
		// we're *not* visible
		this.style.display = 'none';
	}
	
	/**
	 * called after document's content has been loaded
	 */
	_onLoaded() {
		console.debug('Document loaded.');
		// now's the time to move our children to the target element
		this._moveContent();
	}
	
	/**
	 * moves our children to the target element
	 */
	_moveContent() {
		console.debug('Moving content to target element...');
		const target = this.getAttribute(ATTR_TARGET);
		if ( (target !== null) && (target.length > 0) ) {
			const te = document.getElementById(target);
			if ( te instanceof HTMLElement ) {
				const cn = this.childNodes;
				while ( cn.length > 0 ) {
					const n = cn[0];
					this.removeChild(n);
					te.appendChild(n);
				}
			} else {
				console.warn(`No DOM element with ID "${target}" found! Content will be invisible.`);
			}
		}
		else {
			console.warn('No "target" attribute specified! Content will be invisible.');
		}
	}

	/**
	 * @returns {String} the custom tag name
	 */
	static get customTag() {
		return CUSTOM_TAG;
	}
}